import { render, staticRenderFns } from "./Head.vue?vue&type=template&id=4c7e51de&scoped=true&"
import script from "./Head.vue?vue&type=script&lang=js&"
export * from "./Head.vue?vue&type=script&lang=js&"
import style0 from "./Head.vue?vue&type=style&index=0&id=4c7e51de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7e51de",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PatronImage: require('/home/bitrix/frontend/components/forms/PatronImage.vue').default,GiftPatron: require('/home/bitrix/frontend/components/forms/GiftPatron.vue').default,Patron: require('/home/bitrix/frontend/components/forms/Patron.vue').default,MtModalFull: require('/home/bitrix/frontend/components/Modal/MtModalFull.vue').default,Popup: require('/home/bitrix/frontend/components/masterpiece/Popup.vue').default,MtArrowLink: require('/home/bitrix/frontend/components/other/MtArrowLink.vue').default,Viewer360: require('/home/bitrix/frontend/components/masterpiece/Viewer360.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default})
